
namespace Matrix.Visualizer {

    @Serenity.Decorators.registerClass()
    export class GraphInstanceDialog extends Serenity.EntityDialog<GraphInstanceRow, any> {
        protected getFormKey() { return GraphInstanceForm.formKey; }
        protected getIdProperty() { return GraphInstanceRow.idProperty; }
        protected getLocalTextPrefix() { return GraphInstanceRow.localTextPrefix; }
        protected getNameProperty() { return GraphInstanceRow.nameProperty; }
        protected getService() { return GraphInstanceService.baseUrl; }

        protected form = new GraphInstanceForm(this.idPrefix);

    }
}